module.exports = __webpack_public_path__ + "static/media/Customer360.a49e3dca.svg";